import * as types from './mutation-types'

export const showStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('show/' + id + '/store').then((response) => {
            resolve(response)
            commit(types.UPDATE_STORE, response.data.store)
            commit(types.UPDATE_CURRENT_STORE, response.data.store)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const loadStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/stores/collection?status='+ data.status + '&search=' + data.search).then((response) => {
            commit(types.LOAD_STORE, response.data.store)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const loadWarehouses = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/stores/collection').then((response) => {
            commit(types.LOAD_WAREHOUSES, response.data.store)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const getStoreProductSaleEment = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/stores/' + id + '/products/initialiaze').then((response) => {
            // commit(types.UPDATE_STORE,response)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const updateStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('update/'+data.id+'/store', data).then((response) => {
            commit(types.UPDATE_STORE,response.data.store)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const updateStoreProductAvailable = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('update/'+ data.id+'/product/available', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const launchdeliveredProduct = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('launch/delivery/shop/'+data.shop_ask_id+'/ask', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const archiveStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('archive/'+data.id+'/store', data).then((response) => {
            commit(types.UPDATE_STORE,response.data.store)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const unarchiveStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('unarchive/'+data.id+'/store', data).then((response) => {
            commit(types.UPDATE_STORE,response.data.store)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const deleteStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.delete(`delete/${id}/store`).then((response) => {
            commit(types.DELETE_STORE, id)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const createStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('store/store', data).then((response) => {
            commit(types.ADD_STORE, response.data.store)
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const removeEntryStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.delete('remove/entry/'+ id +'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const removeOutputStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.delete('remove/output/'+data.id_output+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const createEntrieStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('store/entry/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const createOutputStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('store/output/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const createOutputShop = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('store/output/shop', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const getDetailsProd = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/quantity/' + data.entityFromable_id + '/' + data.productSaleElement_id + '/output').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const numberEntryOutput = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.get('get/numberEntryOutput').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const showEntrieStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('show/entrie/'+id+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const showOutputStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('show/output/'+id+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const sendOutputStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('validate/'+id+'/output').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const removeProdOutputStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.delete('remove/prod/output/'+id+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const removeEntrieStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.delete('remove/prod/entry/'+id+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const removeShopOutputStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.delete('remove/shop/output/'+data.shop_id+'/'+data.id+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const removeProdEntrieStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.delete('remove/prod/entrie/'+id+'/store').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const sendUpdateOutputStore = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('validate/'+id+'/output').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}


export const updateOutputStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('update/output/'+data.id+'/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const updateOutputShop = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('update/output/'+data.id+'/shop', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}


export const updateEntrieStore = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('update/entrie/'+data.id+'/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const receiveShopAsk = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('receive/shop/'+data.id+'/ask', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const inProgessShopAsk = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.post('inprogress/shop/'+data.id+'/ask', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const getEntryOutput = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/entry/output/'+id+'/elements').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateEntryLog = ({commit, dispatch, state}, data) => {
    return new Promise((resolve, eject) => {
        window.axios.patch('update/entrielog/'+data.id+'/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })
    })
}

export const showStoreAskProduct = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('show/shop/' + id + '/ask/product/collection').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })   
    })
}

export const shopAsk = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('show/shop/' + id + '/ask').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })   
    })
}

export const shopAskProducts = ({commit, dispatch, state}, id) => {
    return new Promise((resolve, eject) => {
        window.axios.get('show/shop/' + id + '/ask/product/collection').then((response) => {
            resolve(response)
        }).catch((err) => {
            eject(err)
        })   
    })
}

export const validateStoreEntry = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/'+data.id+'/validate/entry',data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const validateEntryInStore = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post('validate/'+ id +'/entry').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

